module.exports = __webpack_public_path__ + "frontend/img/icon-result-10-20.b70c8ae8.svg";